<template>
    <div id="app">
        <flow-panel></flow-panel>
    </div>
</template>

<script>
    import FlowPanel from '@/components/ef/panel'

    export default {
        name: 'App',
        components: {
            FlowPanel
        }
    }
</script>



// WEBPACK FOOTER //
// src/App.vue